import * as xlsx from 'xlsx';
import {
  DELETE_BUBBLES,
  SAVE_BUBBLES,
  GET_BUBBLES,
} from '../store/bubbles/actions/actionTypes';
import { DIAGRAM_EXPORT_HEADERS } from '../helpers/diagram/diagramImportConstants';
import {
  buildDiagramExportRows,
  formatDiagramImportValue,
  getPreservedDiagramBubbles,
  prepareBubbleForBulkSave,
} from '../helpers/diagram/diagramImportHelpers';
import parseDiagramImportSpreadsheet from '../helpers/diagram/parseDiagramImportSpreadsheet';

export default {
  methods: {
    formatValue(value) {
      return formatDiagramImportValue(value);
    },

    async exportDiagramData() {
      const taskBubbles = await this.$store.dispatch(
        GET_BUBBLES,
        this.currentTask._id
      );
      const workSheetBubbles = buildDiagramExportRows(taskBubbles);
      const workbook = xlsx.utils.book_new();
      const bubblesSheet = xlsx.utils.json_to_sheet(workSheetBubbles, {
        header: DIAGRAM_EXPORT_HEADERS,
      });
      xlsx.utils.book_append_sheet(workbook, bubblesSheet, 'Bubbles');

      const now = new Date();
      const datetimeString = `${now.getFullYear()}${now.getMonth()}${now.getDate()}${now.getHours()}${now.getMinutes()}`;

      xlsx.writeFile(
        workbook,
        `Diagram Bubbles List - ${this.currentTask.title} - ${datetimeString}.xlsx`
      );
    },

    handleDiagramImportAdd(event) {
      const file = event.target.files[0];
      event.target.value = '';
      if (!file) {
        return;
      }

      const fileReader = new FileReader();
      fileReader.onload = (onloadEvent) => {
        const processFile = async () => {
          try {
            let existingBubbles = await this.$store.dispatch(
              GET_BUBBLES,
              this.currentTask._id
            );
            if (!existingBubbles) {
              existingBubbles = [];
            }

            const importedBubbles = this.readDiagramFile(
              onloadEvent.target.result,
              existingBubbles
            );
            const preservedBubbles = getPreservedDiagramBubbles(
              existingBubbles
            ).map(prepareBubbleForBulkSave);

            const saveImportedBubbles = async (payloadBubbles) => {
              await this.$store.dispatch(DELETE_BUBBLES, this.currentTask._id);
              await this.$store.dispatch(SAVE_BUBBLES, {
                taskId: this.currentTask._id,
                data: payloadBubbles,
              });
              await this.$store.dispatch(GET_BUBBLES, this.currentTask._id);
            };

            if (!importedBubbles || importedBubbles.length === 0) {
              this.$buefy.dialog.confirm({
                title: 'Warning: Upload Diagram Labels',
                message: `No inspection bubbles found in this file.<br>All inspection labels will be removed${
                  preservedBubbles.length
                    ? ', but arrows, text, and symbols will be kept.'
                    : '.'
                }<br><br>Are you sure you want to proceed?`,
                type: 'is-danger',
                hasIcon: true,
                icon: 'delete',
                confirmText: 'Upload',
                onConfirm: async () => {
                  this.isLoadingTask = true;
                  await saveImportedBubbles(preservedBubbles);
                  window.location.reload();
                },
                onCancel: () => {
                  this.isLoadingTask = false;
                },
              });
              return;
            }

            this.$buefy.dialog.confirm({
              title: 'Warning: Upload Diagram Labels',
              message:
                'Uploading new label/bubble data will override existing inspection data, including measurements and images associated with inspection labels.<br>Arrows, text, and symbols will be kept.<br><br>Are you sure you want to proceed?',
              type: 'is-danger',
              hasIcon: true,
              icon: 'delete',
              confirmText: 'Upload',
              onConfirm: async () => {
                this.isLoadingTask = true;
                await saveImportedBubbles([
                  ...importedBubbles,
                  ...preservedBubbles,
                ]);
                window.location.reload();
                this.isLoadingTask = false;
              },
              onCancel: () => {
                this.isLoadingTask = false;
              },
            });
          } catch (error) {
            console.error('Error during diagram import:', error);
            this.$buefy.snackbar.open({
              message:
                'An unexpected error occurred while importing the worksheet.',
              type: 'is-danger',
              position: 'is-top',
              duration: 5000,
              pauseOnHover: true,
            });
          }
          this.isLoadingTask = false;
        };
        processFile();
      };
      fileReader.readAsBinaryString(file);
    },

    readDiagramFile(binary, existingBubbles) {
      return parseDiagramImportSpreadsheet(binary, existingBubbles, {
        formatValue: (value) => this.formatValue(value),
        onInvalidHeader: () => {
          this.$buefy.toast.open({
            duration: 5000,
            message: this.$t('diagram_excel_import_failed'),
            type: 'is-danger',
          });
          this.isLoadingTask = false;
        },
      });
    },
  },
};
